import { render, staticRenderFns } from "./PartnerCalculationsReturns.vue?vue&type=template&id=c2215248&scoped=true"
import script from "./PartnerCalculationsReturns.vue?vue&type=script&lang=js"
export * from "./PartnerCalculationsReturns.vue?vue&type=script&lang=js"
import style0 from "./PartnerCalculationsReturns.vue?vue&type=style&index=0&id=c2215248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2215248",
  null
  
)

export default component.exports